import Architecture from './Architecture'

export default Architecture
